import React, { useState } from 'react';
import {
  Container,
  Box,
  Tabs,
  Tab,
  Typography,
  Paper,
  Tooltip,
  IconButton
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import FinancialTable from './financialTable';
import FinancialPrediction from './financialPrediction';
import FinancialBudget from './financialBudget';
import FinancialIncome from './financialIncome';
import FinancialTarget from './financialTarget';
import FinancialCashFlow from './financialCashFlow';
import FinancialSource from './financialSource';
import NavigationButton from './NavigationButton';

// Tab Panel komponenti
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
      style={{ width: '100%' }}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const Financial = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleNext = () => {
    setValue((prev) => prev + 1);
  };

  // Tab başlıkları ve tooltip içerikleri
  const tabs = [
    {
      label: "Kar Tahmin ve Beklentileri",
      tooltip: "Kar tahminleri ve beklentileri hakkında detaylı bilgiler"
    },
    {
      label: "Proje Bütçesi",
      tooltip: "Proje bütçe detayları ve planlaması"
    },
    {
      label: "Yatırım Bütçesi",
      tooltip: "Yatırım bütçesi ve planlaması"
    },
    {
      label: "Gelir Kalemleri",
      tooltip: "Gelir kalemleri ve detayları"
    },
    {
      label: "Satış Hedefleri",
      tooltip: "Satış hedefleri ve planlaması"
    },
    {
      label: "Nakit Akım Tablosu",
      tooltip: "Nakit akışı ve finansal planlama"
    },
    {
      label: "Açıklama ve Belgeler",
      tooltip: "İlgili açıklamalar ve belgeler"
    }
  ];

  return (
    <Container maxWidth="xl">
      <Box
        sx={{
          bgcolor: 'background.paper',
          display: 'flex',
          flexDirection: 'column',
          mt: 2,
          border: 1,
          borderColor: 'divider',
          borderRadius: 1,
          overflow: 'hidden'
        }}
      >
        <Paper elevation={3}>
          <Tabs
            orientation="horizontal"
            variant="scrollable"
            value={value}
            onChange={handleChange}
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
              '& .MuiTab-root': {
                minHeight: 48,
                py: 1,
              }
            }}
          >
            {tabs.map((tab, index) => (
              <Tab
                key={index}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {tab.label}
                    <Tooltip title={tab.tooltip} placement="top">
                      <IconButton size="small" sx={{ ml: 1 }}>
                        <HelpOutlineIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                }
              />
            ))}
          </Tabs>
        </Paper>

        {/* Tab içerikleri */}
        <TabPanel value={value} index={0}>
          <Typography variant="h6" gutterBottom>
            Kar Tahmin ve Beklentileri
          </Typography>
          <FinancialPrediction />
          <NavigationButton onNext={handleNext} />
        </TabPanel>

        <TabPanel value={value} index={1}>
          <Typography variant="h6" gutterBottom>
            Proje Bütçesi
          </Typography>
          <FinancialTable />
          <NavigationButton onNext={handleNext} />
        </TabPanel>

        <TabPanel value={value} index={2}>
          <Typography variant="h6" gutterBottom>
            Yatırım Bütçesi
          </Typography>
          <FinancialBudget />
          <NavigationButton onNext={handleNext} />
        </TabPanel>

        <TabPanel value={value} index={3}>
          <Typography variant="h6" gutterBottom>
            Gelir Kalemleri
          </Typography>
          <FinancialIncome />
          <NavigationButton onNext={handleNext} />
        </TabPanel>

        <TabPanel value={value} index={4}>
          <Typography variant="h6" gutterBottom>
            Satış Hedefleri
          </Typography>
          <FinancialTarget />
          <NavigationButton onNext={handleNext} />
        </TabPanel>

        <TabPanel value={value} index={5}>
          <Typography variant="h6" gutterBottom>
            Nakit Akım Tablosu
          </Typography>
          <FinancialCashFlow />
          <NavigationButton onNext={handleNext} />
        </TabPanel>

        <TabPanel value={value} index={6}>
          <Typography variant="h6" gutterBottom>
            Açıklama ve Belgeler
          </Typography>
          <FinancialSource />
        </TabPanel>
      </Box>
    </Container>
  );
};

export default Financial;